module.exports = __webpack_public_path__ + "img/Home.6b56a6d5.svg";